// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type LockIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from lock.svg
 */
export default function LockIcon(props: LockIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="LockIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M11.995 4.783C11.882 2.123 10.69 1 8 1 5.239 1 4 2.239 4 5v.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V5l.005-.176C6.096 3.249 6.402 3 8 3c1.657 0 2 .343 2 2v.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V5zM5.5 9a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zM4 7a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1z"
        />
      </g>
    </svg>
  );
}
